var CryptoJS = require("crypto-js");

const encryptData = (data) => {
    var ciphertext = CryptoJS.AES.encrypt(data, 'encrypteddata').toString();
    return ciphertext;
}

const dycryptData = (ciphertext) => {
    var bytes = CryptoJS.AES.decrypt(ciphertext, 'encrypteddata');
    var originalText = bytes.toString(CryptoJS.enc.Utf8);

    return originalText;
}
export default { encryptData, dycryptData };